export enum ListDensity {
  DENSE = "dense",
  CONFORTABLE = "confortable",
}
